import { render, staticRenderFns } from "./userSet.vue?vue&type=template&id=25e96486&"
import script from "./userSet.vue?vue&type=script&lang=js&"
export * from "./userSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports